import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between px-6 md:px-10 lg:px-16 h-18 md:h-20">
        <div className="hidden md:flex items-center gap-8">
          <a href="#services" className={`text-sm font-medium tracking-wide transition-colors duration-300 whitespace-nowrap ${scrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/80 hover:text-white'}`}>Services</a>
          <a href="#coverage" className={`text-sm font-medium tracking-wide transition-colors duration-300 whitespace-nowrap ${scrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/80 hover:text-white'}`}>Coverage</a>
          <a href="#about" className={`text-sm font-medium tracking-wide transition-colors duration-300 whitespace-nowrap ${scrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/80 hover:text-white'}`}>About</a>
        </div>

        <a href="/" className="absolute left-1/2 -translate-x-1/2 flex items-center gap-1.5 cursor-pointer">
          <span className={`font-heading text-xl md:text-2xl font-bold tracking-wider transition-colors duration-300 ${scrolled ? 'text-foreground-950' : 'text-white'}`}>
            INTL<span className="text-accent-500">.</span>
          </span>
        </a>

        <div className="hidden md:flex items-center gap-6">
          <a href="tel:+18888663428" className={`text-sm font-medium tracking-wide transition-colors duration-300 whitespace-nowrap ${scrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/80 hover:text-white'}`}>
            <i className="ri-phone-line mr-1.5"></i>888-866-3428
          </a>
          <a href="#track" className={`text-sm font-medium tracking-wide transition-colors duration-300 whitespace-nowrap ${scrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/80 hover:text-white'}`}>Track</a>
          <a href="#contact" className={`text-sm font-medium tracking-wide transition-colors duration-300 whitespace-nowrap ${scrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/80 hover:text-white'}`}>Contact</a>
          <button className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors duration-300 cursor-pointer ${scrolled ? 'text-foreground-600 hover:text-foreground-950 hover:bg-background-200' : 'text-white/70 hover:text-white hover:bg-white/10'}`}>
            <i className="ri-search-line text-base"></i>
          </button>
          <a href="#quote" className={`px-5 py-2.5 rounded-full text-sm font-semibold whitespace-nowrap transition-all duration-300 cursor-pointer ${scrolled ? 'bg-primary-500 text-white hover:bg-primary-600' : 'bg-white text-foreground-950 hover:bg-white/90'}`}>
            Get Quote
          </a>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-full cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i className={`text-xl transition-colors duration-300 ${scrolled ? 'text-foreground-950' : 'text-white'} ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-lg border-t border-background-200/60 px-6 py-6 flex flex-col gap-4">
          <a href="tel:+18888663428" className="text-foreground-800 text-base font-medium py-2 cursor-pointer flex items-center gap-2" onClick={() => setMobileOpen(false)}>
            <i className="ri-phone-line text-accent-500"></i>888-866-3428
          </a>
          <a href="#services" className="text-foreground-800 text-base font-medium py-2 cursor-pointer" onClick={() => setMobileOpen(false)}>Services</a>
          <a href="#coverage" className="text-foreground-800 text-base font-medium py-2 cursor-pointer" onClick={() => setMobileOpen(false)}>Coverage</a>
          <a href="#about" className="text-foreground-800 text-base font-medium py-2 cursor-pointer" onClick={() => setMobileOpen(false)}>About</a>
          <a href="#track" className="text-foreground-800 text-base font-medium py-2 cursor-pointer" onClick={() => setMobileOpen(false)}>Track</a>
          <a href="#contact" className="text-foreground-800 text-base font-medium py-2 cursor-pointer" onClick={() => setMobileOpen(false)}>Contact</a>
          <a href="#quote" className="mt-2 w-full text-center px-5 py-3 rounded-full bg-primary-500 text-white font-semibold text-base cursor-pointer" onClick={() => setMobileOpen(false)}>Get Quote</a>
        </div>
      )}
    </nav>
  );
}